import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery"; // For jQuery
import "./Login.css"; // Custom CSS file
import Header from "../Header";
import Footer from "../Footer";
import Registesion from './Registesion'
import { Link } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});

  // Form validation
  const validate = () => {
    let valid = true;
    let newErrors = {};

    if (!formData.username) {
      newErrors.username = "Username is required.";
      valid = false;
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      alert("Login successful!");
    } else {
      alert("Please fill all required fields.");
    }
  };

  // jQuery for hover effect on buttons
  $(document).ready(() => {
    $(".login-btn").hover(
      function () {
        $(this).css("transform", "scale(1.05)");
      },
      function () {
        $(this).css("transform", "scale(1)");
      }
    );
  });

  return (
    <div>
      <Header/>
    <div className="login-container d-flex justify-content-center align-items-center">
      <div className="login-card p-4 rounded">
        <h3 className="text-center mb-4" style={{fontSize:'45px',paddingLeft:'45px'}}>USER LOGIN</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-4">
            <div className="input-group">
              <span className="input-group-text bg-light">
                <i className="fas fa-user"></i>
              </span>
              <input
                type="text"
                className={`form-control ${
                  errors.username ? "is-invalid" : ""
                }`}
                placeholder="Username"
                value={formData.username}
                onChange={(e) =>
                  setFormData({ ...formData, username: e.target.value })
                }
              />
              {errors.username && (
                <div className="invalid-feedback">{errors.username}</div>
              )}
            </div>
          </div>

          <div className="form-group mb-4">
            <div className="input-group">
              <span className="input-group-text bg-light">
                <i className="fas fa-lock"></i>
              </span>
              <input
                type="password"
                className={`form-control ${
                  errors.password ? "is-invalid" : ""
                }`}
                placeholder="Password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
              {errors.password && (
                <div className="invalid-feedback">{errors.password}</div>
              )}
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-100 login-btn">
            LOGIN
          </button>
        </form>
        <Link to="/registration"className="text-decoration-none">
           New Registration
        </Link>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default Login;
